// import Filters MUST be here for correct work!!!
import RefBooksModule from './refbooks/refbooks.module';
import Capabilities from '../collection/access/capabilities';
import Model from '../model/model';
import Rules from '../collection/access/rules';
import States from '../collection/task.states';
import Statuses from '../collection/statuses';

import { hashify } from '../utils/arrays';
import { sort, naturalOrder, reverseOrder, asc, desc } from '../collection/sort';




const defaults = {
    roles: undefined,
    capabilities: undefined,
};

const FiltersModel = Model.extend( {

    defaults,

    computeds: {

        changed: {
            deps: ['roles', 'capabilities'],
            get() {
                // Model, not FiltersModel:
                // Task is enough for diff() call;
                // and usage of Model will produce
                // infinite recursion at momemnt of 
                // computing "changed" for a new Model.
                const original = new Model( defaults );
                const diff = this.diff( original );
                return !!diff.length;
            }
        }

    }
} );





export default RefBooksModule.extend( {

    template: 'jst/module.capabilities',

    url() {
        return `capabilities`;
    },

    open() {
        return this.capabilities_ = new Capabilities( [], {} ),
            this.roles_ = this.options.roles,
            this.states_ = new States( [], {} ),
            this.statuses_ = new Statuses( [], {} ),
            Promise.all( [this.capabilities_.fetch(), this.states_.fetch(), this.statuses_.fetch()] )
                .then( () => this.rules_ = new Rules( [], {
                    capabilities: this.capabilities_,
                    roles: this.roles_,
                    states: this.states_,
                } ) )
                .then( () => sort( this.capabilities_.models,
                    naturalOrder, ['label'] ) )
                .then( () => this.rules_.fetch() )
                .then( () => this.bind( new FiltersModel( this.state().filters ) ) );
    },

    start() {
        return this.listenTo( this.model, 'change', () => Promise.resolve()
            .then( () => this.setState( { 
                filters: this.model.toJSON(),
                page: 1, 
            } ) )
            .then( () => this.render() )
            .then( () => this.navigated() ) );
    },

    stop() {
        return this.stopListening( this.model ),
            this;
    },

    serialize() {
        const roles = this.model.get( 'roles' ) && this.model.get( 'roles' ).length
            ? hashify( this.model.get( 'roles' ) )
            : undefined;
        const capabilities = this.model.get( 'capabilities' ) && this.model.get( 'capabilities' ).length
            ? hashify( this.model.get( 'capabilities' ) )
            : undefined;

        const singleRoleFiltered = Object.keys( roles || {} ).length === 1;
        const singleCapabilityFiltered = Object.keys( capabilities || {} ).length === 1;

        const models = this.rules_.filter( model => {
            // skip unknown roles
            if (!model.get( 'role' ))
                return false;

            // skip unknown caps
            if (!model.get( 'capability' ))
                return false;

            if (roles)
                if (!roles[model.get( 'role_id' )]) return false;
                
            if (capabilities)
                if (!capabilities[model.get( 'capability_id' )]) return false;

            return true;
        } );

        const { page, sort: field, direction, limit, } = this.state();

        const columns = field === 'role'
            ? ['role.name', 'capability.label', 'ownership', 'stage']
            : ['capability.label', 'role.name', 'ownership', 'stage'];
        const sortingRules = 'asc' === direction
            ? asc( models, columns )
            : desc( models, columns );

        return sortingRules.then( ruleModels => {

            const rules = new Rules( ruleModels
                .filter( (model, index) =>
                    index >= (page - 1) * limit && index < page * limit )
                .map( rule => {
                    const json = rule.toJSON();
                    return new Model( {
                        ...json,
                        ownership: rule.get( 'ownership' ),
                        stage: rule.get( 'stage' ),
                        status: rule.get( 'status' ),
                        is_template: rule.get( 'is_template' ),
                        others: rule.get( 'others' ),
                    } );
                } ),
                {} );

            rules.total = ruleModels.length;
            rules.page = page;
            rules.limit = limit;

            return {
                capabilities: this.capabilities_.toJSON(),
                roles: this.roles_.toJSON(),
                states: this.states_.toJSON(),
                statuses: this.statuses_.toJSON(),
                singleRoleFiltered,
                singleCapabilityFiltered,
                sort: field, direction,
                rules,
            };
        } );
    },

    events: {

        'click .-sort'({currentTarget}) {
            const { sort, direction, } = currentTarget.dataset;
            return this.setState( { page: 1, sort, direction, } ),
                this.render().then( () => this.navigated() );
        },

        'click .-limit'({currentTarget}) {
            const { limit } = currentTarget.dataset;
            return this.setState( { page: 1, limit: limit, } ),
                this.render().then( () => this.navigated() );
        },

        'click .-clear-filters'() {
            this.model.set( { ...defaults } );
        },

    },

    [RefBooksModule.event( 'Paging:page')](page) {
        return this.setState( { page: +page, } ),
            this.render().then( () => this.navigated() );
    },

}, {

} );


// WEBPACK FOOTER //
// ./src/js/module/capabilities.js